import firebase from 'firebase';
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

// Your web app's Firebase configuration

/*var firebaseConfig = {
    apiKey: "AIzaSyAepRCANG8l6GbC-Hz5p8YjjwglX7jITyE",
    authDomain: "ies-iluminacion.firebaseapp.com",
    databaseURL: "https://ies-iluminacion-default-rtdb.firebaseio.com",
    projectId: "ies-iluminacion",
    storageBucket: "ies-iluminacion.appspot.com",
    messagingSenderId: "792297242907",
    appId: "1:792297242907:web:8b6beed99088d9422593be",
    measurementId: "G-FELJH5LZ2H"
  };*/
  var firebaseConfig = {
    apiKey: "AIzaSyAa3bcNKDo7C0K4jkgcsWjK8I0YWV5zKFw",
    authDomain: "construyendo-futuro-sume.firebaseapp.com",
    projectId: "construyendo-futuro-sume",
    storageBucket: "construyendo-futuro-sume.appspot.com",
    messagingSenderId: "141570746612",
    appId: "1:141570746612:web:b16611c3d0fece3f70d6a1",
    measurementId: "G-B6PPYX2XKS"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();


class Firebase {

    app;

    constructor(){
            
        this.app = firebase;
        this.conexion = firebase.database();
        
    }


    obtener_webinars_usuario = (url, campo, valor, funct) => {

        console.log('ojal exista');
        this.conexion.ref(url).once('value', (objetos) => {

            console.log('existio');

            if (this.collectionToArr(objetos).length > 0) {

                console.log('esta');

                let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {

                    console.log(objeto[campo]);
                    if (objeto[campo] === valor) {
                        return true;
                    } else {
                        return false;
                    }
                });

                console.log(objeto_buscado);

                if(objeto_buscado.length > 0){
                    return funct(objeto_buscado[0]);
                }else{
                    console.log('no enconbtro nada');
                    return funct(null);
                }
            }
            console.log('no esta');
            return funct(null);
        })
    }
    
    obtener_objeto = (url, campo, valor, funct) => {
        
        this.conexion.ref(url).once('value', (objetos) => {

            if (this.collectionToArr(objetos).length > 0) {

                let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
                    if (objeto[campo] === valor) {
                        return true;
                    } else {
                        return false;
                    }
                });
                if(objeto_buscado.length > 0){
                    return funct(objeto_buscado[0]);
                }else{
                    const datos_objeto = {};
                    datos_objeto[campo] = valor;
                    this.escribir(url, undefined, datos_objeto, funct);
                }
            } else {
                const datos_objeto = {};
                datos_objeto[campo] = valor;
                this.escribir(url, undefined, datos_objeto, funct);
            }
        });
    }

    verificar_objeto = (url, campo, valor, funct) => {
        
        this.conexion.ref(url).once('value', (objetos) => {

            if (this.collectionToArr(objetos).length > 0) {

                let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
                    if (objeto[campo] === valor) {
                        return true;
                    } else {
                        return false;
                    }
                });


                if(objeto_buscado.length > 0){
                    funct(true);
                }else{
                    funct(false);
                }
            } else {
                funct(false);
            }
        });
    }

    escribir = (url, id, objeto, funct) => { //sendquestion || updateQuestion
        let key = '';
        if (id === undefined) {
            key = this.conexion.ref(url).push().key;
        } else {
            key = id;
        }

        console.log(objeto);

        this.conexion.ref(url).child(key).set(objeto, () => {
            objeto['key'] = key;
            return funct(objeto);
        });
    }

    obtener_objetos = (url, escuchar ,funct) => { //questions

        if(escuchar){
            this.conexion.ref(url).orderByChild("num_pregunta").on('value', (objetos) => {
                return funct(this.collectionToArr(objetos));
            })
        }else{
            this.conexion.ref(url).orderByChild("num_pregunta").once('value', (objetos) => {
                return funct(this.collectionToArr(objetos));
            })
        }
    }

    obtener_parametro = (url, escuchar ,funct) => {

        if(escuchar){
            this.conexion.ref(url).on('value', (parametro) => {
                return funct(parametro);
            })
        }else{
            this.conexion.ref(url).once('value', (parametro) => {
                return funct(parametro);
            })
        }
    }

    collectionToArr = (collection) => {
        var rows = [];
        if (collection && collection.val()) {

            collection.forEach((obj) => {
                let item = obj.val();
                item.key = obj.key;
                rows.push(item);
            });
        }
        return rows;
    }

    verificar_objeto_dia = (url, campo, valor, dia, funct) => {
        
        this.conexion.ref(url).once('value', (objetos) => {

            if (this.collectionToArr(objetos).length > 0) {

                let objeto_buscado = this.collectionToArr(objetos).filter(objeto => {
                    if (objeto[campo] === valor && dia === objeto['dia']) {
                        return true;
                    } else {
                        return false;
                    }
                });
                if(objeto_buscado.length > 0){
                    funct(true);
                }else{
                    funct(false);
                }
            } else {
                funct(false);
            }
        });
    }


}

export default Firebase;